module.exports = __webpack_public_path__ + "static/media/cabane_associations.575d1f5e.png";